module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/SMT车间整条NB线.5cd8a975.jpg";